/**
 * @GENERATED from Figma node 3638:51949
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const WarningBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      d="M8.333 14.289 5.444 11.4 2.556 14.29 1 12.733l2.889-2.889L1 6.956 2.556 5.4l2.888 2.889L8.334 5.4l1.555 1.556L7 9.844l2.889 2.89zM6.867 16.4H1v2.2h5.867zM14.933 16.4H9.067v2.2h5.866zM17.133 16.4H23v2.2h-5.867z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(WarningBright);
export { ForwardRef as WarningBright };
